import Vue from "vue";
import Router from "vue-router";
import Index from "@/views/Index/index";
import OfferOther from "@/views/Offer/index";
import OfferTwentytwo from "@/views/Offer/offer_2022";
import OfferTwentythree from "@/views/Offer/offer_2023";
import OfferTwentyfour from "@/views/Offer/offer_2024";
import OfferTwentyfive from "@/views/Offer/offer_2025";
import OfferTwentysix from "@/views/Offer/offer_2026";
import AllOffer from "@/views/Offer/offer_all";
import Subscribe from "@/views/Subscribe/index";
import SubscribeSH from "@/views/SubscribeSH/index";
import SubscribeB from "@/views/SubscribeB/index";

import Subscribe0001 from "@/views/Subscribe0001/index";

import Apply from "@/views/Apply/index";
import ApplyList from "@/views/Apply/list";
import ApplyTeacher from "@/views/Apply/teacher";

// 咨询团队
import Team from "@/views/Team/team";

// 领航
import Pilotage from "@/views/Pilotage/index";
import PilotageList from "@/views/Pilotage/list";
import PilotageTeacher from "@/views/Pilotage/teacher";

import Global from "@/views/Global/index";
import GlobalDetails from "@/views/Global/details";
import signature from "@/views/Global/signature";


// 登录注册
const Lodin = () =>
    import("@/views/lodin/lodin");
// 找回密码
const RetrievePass = () =>
    import("@/views/lodin/retrievepass");
// 注册
const Register = () =>
    import("@/views/lodin/register");

Vue.use(Router);

const router = new Router({
    routes: [{
        path: "/",
        name: "index",
        component: Index,
        meta: {
            title: "世毕盟教育"
        }
    },
    {
        path: "/offer2021",
        name: "OfferOther",
        component: OfferOther,
        meta: {
            title: "世毕盟教育"
        }
    },
    {
        path: "/alloffer",
        name: "AllOffer",
        component: AllOffer,
        meta: {
            title: "世毕盟教育"
        }
    },
    {
        path: "/offer2022",
        name: "OfferTwentytwo",
        component: OfferTwentytwo,
        meta: {
            title: "世毕盟教育"
        }
    },
    {
        path: "/offer2023",
        name: "OfferTwentythree",
        component: OfferTwentythree,
        meta: {
            title: "世毕盟教育"
        }
    },
    {
        path: "/offer2024",
        name: "OfferTwentyfour",
        component: OfferTwentyfour,
        meta: {
            title: "世毕盟教育"
        }
    },
    {
        path: "/offer2025",
        name: "OfferTwentyfive",
        component: OfferTwentyfive,
        meta: {
            title: "世毕盟教育"
        }
    },
    {
        path: "/offer2026",
        name: "OfferTwentysix",
        component: OfferTwentysix,
        meta: {
            title: "世毕盟教育"
        }
    },
    {
        path: "/offer",
        name: "OfferTwentysix",
        component: OfferTwentysix,
        meta: {
            title: "世毕盟教育"
        }
    },
    {
        path: "/subscribe",
        name: "subscribe",
        component: Subscribe,
        meta: {
            title: "预约咨询-世毕盟"
        }
    },
    {
        path: "/subscribe_sh",
        name: "subscribe_sh",
        component: SubscribeSH,
        meta: {
            title: "预约咨询-世毕盟"
        }
    },
    {
        path: "/subscribe_b",
        name: "subscribe_b",
        component: SubscribeB,
        meta: {
            title: "预约咨询-世毕盟"
        }
    },
    {
        path: "/subscribe_0001",
        name: "subscribe_0001",
        component: Subscribe0001,
        meta: {
            title: "在线预约世毕盟负责人咨询"
        }
    },
    {
        path: "/apply",
        name: "apply",
        component: Apply,
        meta: {
            title: "世毕盟本科申请"
        }
    },
    {
        path: "/applylist",
        name: "applylist",
        component: ApplyList,
        meta: {
            title: "世毕盟本科申请"
        }
    },
    {
        path: "/applyteacher",
        name: "applyteacher",
        component: ApplyTeacher,
        meta: {
            title: "世毕盟本科申请"
        }
    },
    {
        path: "/team",
        name: "Team",
        component: Team,
        meta: {
            title: "咨询团队"
        }
    },
    {
        path: "/pilotage",
        name: "pilotage",
        component: Pilotage,
        meta: {
            title: "领航研成功案例"
        }
    },
    {
        path: "/pilotagelist",
        name: "pilotagelist",
        component: PilotageList,
        meta: {
            title: "领航研成功案例"
        }
    },
    {
        path: "/pilotageteacher",
        name: "pilotageteacher",
        component: PilotageTeacher,
        meta: {
            title: "领航研成功案例"
        }
    },
    {
        path: "/global",
        name: "global",
        component: Global,
        meta: {
            title: "世毕盟全球签"
        }
    },
    {
        path: "/globaldetails",
        name: "globaldetails",
        component: GlobalDetails,
        meta: {
            title: "世毕盟全球签"
        }
    },
    {
        path: "/signature",
        name: "signature",
        component: signature,
        meta: {
            title: "世毕盟全球签"
        }
    },
    {
        path: "/lodin",
        component: Lodin,
        name: "lodin",
        meta: {
            lodin: false,
            title: "登录"
        }
    },
    {
        path: "/retrievepass",
        component: RetrievePass,
        name: "retrievepass",
        meta: {
            lodin: false,
            title: "找回密码"
        }
    },
    {
        path: "/register",
        component: Register,
        name: "register",
        meta: {
            lodin: false,
            title: "注册"
        }
    },
    ]
});

// 全局拦截器
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

export default router;